import { render, staticRenderFns } from "./UserHeaderList.vue?vue&type=template&id=23fcbbce"
import script from "./UserHeaderList.vue?vue&type=script&lang=js"
export * from "./UserHeaderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports